<div [ngClass]="cssClass">
  <button tabindex="0" [attr.disabled]="disabled?'':null" (click)="click()">
    <span *ngIf="iconCssClass" [ngClass]="['icon', iconCssClass]"></span>
  </button>
  <span class="bar"></span>
  <label [innerHTML]="title" >{{ title | translate }}</label>
</div>
